import { setDataTime } from './recordingsBar.actions';
import { getNpvr } from '../../../../../../Player/utils/PlayRules';

export const dataTimeCalculate = data => async (dispatch, getState) => {
  const { pack_id, group_id, time_used } = data || {};
  let totalTime = null;
  let timeUsed = 0;
  const store = getState();

  const getValueTimeUsed = (time_used, pack_id) => {
    try {
      // obtengo el tiempo del enpoint (en segundos)
      const timeUsedInSeconds = time_used?.[`pack_${pack_id}`] || 0;
      const timeUsedInHrs = timeUsedInSeconds / (60 * 60); // los combierto a horas
      const timeUsedInHrsString = timeUsedInHrs?.toFixed(1) || ''; // redondeo a un decimal
      return Number(timeUsedInHrsString);
    } catch (error) {
      console.error(error);
      return 0;
    }
  };
  timeUsed = getValueTimeUsed(time_used, pack_id);

  totalTime = Number(getNpvr(group_id, store?.linealChannel?.data) || '');

  const payload = {
    timeUsed,
    totalTime,
  };

  dispatch(setDataTime(payload));
};
